"use strict";

import angular from "angular";
angular.module("nucont.accounting.overview").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.overview.dashboard.control-panel", {
            url: "/painel-de-controle",
            params: {},
            views: {
                "submodules@nucont.accounting.overview.dashboard": {
                    component: "accountingControlPanelViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.dashboard.performance", {
            url: "/performance",
            params: {},
            views: {
                "submodules@nucont.accounting.overview.dashboard": {
                    component: "accountingPerformanceViewComponent"
                }
            }
        })
        .state("nucont.accounting.overview.dashboard.indicators", {
            url: "/indicadores",
            params: {},
            views: {
                "submodules@nucont.accounting.overview.dashboard": {
                    component: "accountingIndicatorsViewComponent"
                }
            }
        });
}
